export class CommomRules {
    static passwordMinLength = 8;
    static passwordMinSpecialCharacteres = /.*[*%$#@!&].*/; //"A senha deve conter no mínimo 01 caractere especial ( * % $ # @ ! & )"),
    static passwordMinNumbers = /.*[0-9].*/; //"A senha deve conter no mínimo 01 número"),
    static passwordMinAa_Zz = /^(?=.*[a-z])(?=.*[A-Z]).+$/; //, "A senha deve conter no mínimo 01 letra maiúscula de 01 minúscula")
}